const initialState: Redux.VRM = {
	isOpen: false,
	similarVendors: [],
	factors: [],
	isMatchDetailsVisible: false,
};

export default initialState;
